module.exports = __webpack_public_path__ + "img/Edit_btn_table.b56886c0.svg";